
import { Component, Vue } from 'vue-property-decorator';
import Navigation from '@/components/navigation/Navigation.vue'; // @ is an alias to /src

@Component({
  components: {
    Navigation,
  },
})
export default class Default extends Vue {}
